<template>
  <div class="two-box">
    <div v-if="teacherList && teacherList.length > 0" class="teacher-view">
      <div class="title">
        <p><slot>师资力量</slot></p>
        <el-pagination
          class="redPage"
          :current-page="pageNum"
          :page-size="6"
          layout="prev, next"
          :total="total"
          @prev-click="toprev"
          @next-click="tonext"
        />
      </div>
      <div class="carousel">
        <div v-for="(item, index) in teacherList" :id="`viesww${index}`" :key="index" class="swiperItem" @click="goDetails(item)">
          <div class="teachers">
            <el-image class="terImg" :src="item.terImg" fit="cover" />
            <div class="teachersRight">
              <div class="itemBox">
                <div class="teacher-info">
                  <span class="tName elp">{{ item.nickname }}</span>
                </div>
                <div class="teachersRightb">
                  <span />
                </div>
                <div class="desc_box">
                  <div class="teacher-tips-desc">{{ item.graduateName }}</div>
                </div>
                <div class="teacher-tips" :title="item.tDetail">
                  <div v-html="item.profile" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/common.css'
import { BaseClient } from "@/api/baseCon";
const baseClient = new BaseClient()
export default {
  components: {},
  data() {
    return {
      total: '',
      teacherList: [],
      pageNum: 1
    }
  },
  async created() {
    let params = {
      pageSize: 6,
      pageNum: 1
    }
    baseClient.selectPCPageList(params).then((res) => {
      if (res.data && res.data.rows) {
        this.teacherList = res.data.rows
        this.total = res.data.total
      } else {
        this.teacherList = []
      }
    })
  },
  methods: {
    goDetails(item) {
      const routeUrl = this.$router.resolve({
        path: `/faculty/teacherDetail`,
        query: {
          id: item.id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    tonext(page) {
      this.pageNum = page
      let params = {
        pageSize: 6,
        pageNum: page
      }
      baseClient.selectPCPageList(params).then((res) => {
        if (res.data && res.data.rows) {
          this.teacherList = res.data.rows
          this.total = res.data.total
        } else {
          this.teacherList = []
        }
      })
    },
    toprev(page) {
      this.pageNum = page
      let params = {
        pageSize: 6,
        pageNum: page
      }
      baseClient.selectPCPageList(params).then((res) => {
        if (res.data && res.data.rows) {
          this.teacherList = res.data.rows
          this.total = res.data.total
        } else {
          this.teacherList = []
        }
      })
    }
  }
}
</script>
<style>
.el-popover {
  overflow: hidden;
  padding: 0px;
}
</style>
<style lang="less" scoped>
.two-box {
  width: 100%;
  background: #fff;
}
.teacher-view {
  padding-top: 32px;
}
.nickname {
  padding: 20px 0px;
}
.title {
  width: 1200px;
  margin: auto;
  height: 23px;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  span {
    width: auto;
    height: auto;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a8abbe;
    cursor: pointer;
  }
}
.teacher {
  width: 1200px;
  margin: auto;
  height: 158px;
  margin-bottom: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-bottom: 8px;
}
.carousel {
  display: flex;
  flex-wrap: wrap;
  width: calc(1220px + 25px);
  margin: auto;
  margin-left: calc(50% - 610px);
  margin-bottom: 30px;
  overflow: hidden;
  .swiperItem{
    margin-right: 25px;
    width: 390px;
  }
}
.teachers {
  position: relative;
  z-index: 22;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .terImg {
    position: relative;
    z-index: 22;
    flex-shrink: 0;
    width: 150px;
    height: 225px;
    border-radius: 4px 4px 4px 4px;
  }
  .teachersRight {
    position: absolute;
    top: 32px;
    left: 32px;
    z-index: 11;
    width: 358px;
    height: 225px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #eeeeee;
    .teacher-info {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 22px;
      img {
        width: 4px;
        height: 15px;
        flex-shrink: 0;
      }
      .tName {
        width: 100%;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #27323f;
        text-align: left;
      }
    }
    .teachersRightb {
      width: 120px;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;
      margin-left: 18px;
      span {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #27323f;
      }
    }
    .teacher-tips {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      width: auto;
      height: 61px;
      margin-top: 4px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #000;
    }
    .teacher-tips-desc {
      max-width: 196px;
      height: auto;
      margin-top: 4px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ff5d51;
      padding: 4px 8px;
      border-radius: 4px;
      background: #fff0ef;
      margin-right: 20px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
}
.swiperItem {
  width: 32%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}
.itemBox {
  margin-left: 138px;
}
.desc_box {
  margin-bottom: 16px;
  display: flex;
}
</style>
